const getters = {
  urlParameters(state) {
    const pagingData = [];
    if (state.pagingData) {
      pagingData.push(
          {
            name: state.pagingData.name,
            value: state.pagingData.currentPage
          }
      );
    }

    const itemsPerPage = [];
    if (state.pagingData) {
      pagingData.push(
          {
            name: 'itemsPerPage',
            value: state.pagingData.entriesPerPage
          }
      );
    }

    const sortingData = [];
    if (state.sortingData) {
      sortingData.push(
        {
          name: state.sortingData.name,
          value: state.sortingData.selectedOptionValue
        }
      );
    }

    const parameters = [
      ...pagingData,
      ...itemsPerPage,
      ...sortingData
    ];

    return parameters;
  },
};

export default getters;
